import { Layers, ArrowRight } from 'lucide-react';
import { renderMarkdownText } from '../../utils/markdown';
import { getSectionAnchor } from '../../utils/anchor';

export const ContentSections = ({ sections }) => {
  if (!sections || sections.length === 0) return null;
  return (
    <>
      {[...sections]
        .sort((a, b) => (a.order || 0) - (b.order || 0))
        .map((section) => (
          <section
            key={section.id}
            id={section.anchor || section.id}
            className="py-8 scroll-mt-24"
            data-testid={`content-section-${section.id}`}
          >
            <div className="max-w-5xl mx-auto px-6">
              {section.title && (
                <div className="flex items-center gap-3 mb-6">
                  <Layers className="text-primary" size={22} />
                  <h2 className="font-heading text-2xl md:text-3xl font-bold">{section.title}</h2>
                </div>
              )}
              <div className="space-y-8">
                  {(section.blocks || [])
                    .sort((a, b) => (a.order || 0) - (b.order || 0))
                    .map((block) => {
                      const columns = block.columns || 1;
                      const gridCols = columns === 1 ? 'grid-cols-1' : columns === 2 ? 'grid-cols-1 md:grid-cols-2' : 'grid-cols-1 md:grid-cols-2 lg:grid-cols-3';
                      return (
                        <div key={block.id} className={`grid ${gridCols} gap-8`}>
                          {(block.items || []).map((item, itemIdx) => {
                            const hasContent =
                              (item.type === 'text' && item.text) ||
                              (item.type === 'image' && item.image) ||
                              (item.type === 'cta' && item.cta_text) ||
                              (item.type === 'text_cta' && (item.text || item.cta_text));
                            if (!hasContent) return null;
                            return (
                              <div key={item.id || itemIdx}>
                                {item.type === 'text' && item.text && (
                                  <div
                                    className={`prose prose-invert max-w-none ${
                                      item.fontSize === 'sm' ? 'text-sm' :
                                      item.fontSize === 'lg' ? 'text-lg' :
                                      item.fontSize === 'xl' ? 'text-xl' :
                                      item.fontSize === '2xl' ? 'text-2xl' : ''
                                    }`}
                                    style={{ textAlign: item.textAlign || 'left' }}
                                  >
                                    {renderMarkdownText(item.text)}
                                  </div>
                                )}
                                {item.type === 'image' && item.image && (
                                  <div style={{ textAlign: 'center' }}>
                                    <img
                                      src={item.image.startsWith('http') ? item.image : `${process.env.REACT_APP_BACKEND_URL}${item.image}`}
                                      alt=""
                                      className="rounded-lg inline-block max-w-full"
                                      style={{
                                        width: item.imageHeight && item.imageHeight !== 'auto' && item.imageHeight !== '100'
                                          ? `${item.imageHeight}%`
                                          : '100%'
                                      }}
                                    />
                                  </div>
                                )}
                                {item.type === 'cta' && item.cta_text && (
                                  <div className="flex items-start">
                                    <a
                                      href={item.cta_link || '#'}
                                      target={item.cta_link?.startsWith('http') ? '_blank' : '_self'}
                                      rel="noopener noreferrer"
                                      className="inline-flex items-center gap-2 px-6 py-3 bg-primary hover:bg-primary/90 text-primary-foreground font-medium rounded-full transition-colors"
                                    >
                                      {item.cta_text}
                                      <ArrowRight size={16} />
                                    </a>
                                  </div>
                                )}
                                {item.type === 'text_cta' && (
                                  <div className="space-y-4">
                                    {item.text && (
                                      <div
                                        className={`prose prose-invert max-w-none ${
                                          item.fontSize === 'sm' ? 'text-sm' :
                                          item.fontSize === 'lg' ? 'text-lg' :
                                          item.fontSize === 'xl' ? 'text-xl' : ''
                                        }`}
                                      >
                                        {renderMarkdownText(item.text)}
                                      </div>
                                    )}
                                    {item.cta_text && (
                                      <div className="pt-2 flex justify-end">
                                        <a
                                          href={item.cta_link || '#'}
                                          target={item.cta_link?.startsWith('http') ? '_blank' : '_self'}
                                          rel="noopener noreferrer"
                                          className="inline-flex items-center gap-2 px-6 py-3 bg-primary hover:bg-primary/90 text-primary-foreground font-medium rounded-full transition-colors"
                                        >
                                          {item.cta_text}
                                          <ArrowRight size={16} />
                                        </a>
                                      </div>
                                    )}
                                  </div>
                                )}
                              </div>
                            );
                          })}
                        </div>
                      );
                    })}
                </div>
            </div>
          </section>
        ))}
    </>
  );
};
